export default __webpack_public_path__ + "static/media/salon_front.4439152b.png";